// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-e45b3c74]{display:flex;align-items:center;justify-content:center}.content .password-box[data-v-e45b3c74]{text-align:center;position:relative}.content .forget-pw[data-v-e45b3c74]{position:absolute;top:3.489583rem;right:4.479167rem}.content .el-button[data-v-e45b3c74]{margin-top:1.041667rem}", ""]);
// Exports
module.exports = exports;
